import { useMutation, UseMutationResult } from '@tanstack/react-query';

import {
  SupportApiResponse,
  WiseOwlUpdateChatResponseData,
} from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

import { SupportApi } from '../../clients';

const useWiseOwlCreateChat = ({
  isLoggedIn,
}: {
  isLoggedIn: boolean;
}): UseMutationResult<
  SupportApiResponse<WiseOwlUpdateChatResponseData>,
  any,
  { chatId: string; input: string }
> => {
  return useMutation({
    mutationFn: (args: { chatId: string; input: string }) => {
      const { chatId, input } = args;

      if (!isLoggedIn) {
        return SupportApi.ungatedUpdateWiseOwlChat(chatId, input);
      }

      return SupportApi.updateWiseOwlChat(chatId, input);
    },
  });
};

export default useWiseOwlCreateChat;
